import * as React from 'react';

import {loadStripe} from '@stripe/stripe-js';
import OrderSummary from "../OrderSummary";
import {calculateTotal} from "../utils";
import {wizardPages as pages} from "../OrderWizardContainer";
import {BackButton} from "../buttons/BackButton";

import {useDispatch, useSelector} from "react-redux";
import type {AppState} from "../../AppState";
import {Redirect} from "react-router";
import {updateCreditCardAction} from "../../admin/redux/orderReducer";
import {selectSelectedProducts} from "../../selectors";
import {CardElement, Elements, useElements, useStripe} from "@stripe/react-stripe-js";
import "./paymentStep.scss"
import {SyntheticEvent, useState} from "react";
import {useHistory} from "react-router-dom";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe("pk_test_TYooMQauvdEDq54NiTphI7jx");

export default function PaymentStep() {

	const creditCardEntity = useSelector((state: AppState) => state.order.creditCard)
	const selectedProducts = useSelector(selectSelectedProducts);

	const dispatch = useDispatch();

	const updateCC = (value: any) => {
		console.info(" " + JSON.stringify(value))
		dispatch(updateCreditCardAction(value));
	}

	if(creditCardEntity){
		return <Redirect to="/order/OK/" />
	}

	return (
		<div className="wizardPanel payment-panel">
			<h2 className="wizardHeader">Credit Card Payment</h2>
			<div className="wizardMain">
				<BackButton page={pages.SUMMARY}/>
				<div className="wizardCenter">
					<div className={"description"}>
						Please enter your credit card details and click 'Pay'
					</div>
					<div className={"stripe-payment-panel"}>
						<Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
							<CheckoutForm updateCC={updateCC} amount={calculateTotal(selectedProducts)}/>
						</Elements>
					</div>
				</div>
				<OrderSummary/>
			</div>
		</div>
	);
}


// import React, {SyntheticEvent, useState} from 'react';
// import {CardElement, Elements, useElements, useStripe} from "@stripe/react-stripe-js";
// import './PaymentForm.scss';
//
// import {useHistory} from "react-router-dom";

// from here :

// https://github.com/stripe/react-stripe-js/blob/90b7992c5232de7312d0fcc226541b62db95017b/examples/hooks/1-Card-Detailed.js


// amount
// Test Card :
// 4242424242424242	Visa	Any 3 digits	Any future date

export const CheckoutForm = (props: any) => {
	const history = useHistory();
	const stripe = useStripe();
	const elements = useElements();
	const [error, setError] = useState();
	const [cardComplete, setCardComplete] = useState(false);
	const [processing, setProcessing] = useState(false);
	const [paymentMethod, setPaymentMethod] = useState(null);
	const [billingDetails, setBillingDetails] = useState({
		email: '',
		phone: '',
		name: '',
	});

	const handleSubmit = async (event: SyntheticEvent) => {
		event.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not loaded yet. Make sure to disable
			// form submission until Stripe.js has loaded.
			return;
		}

		if (error) {
			// @ts-ignore
			elements.getElement('card').focus();
			alert("error : " + error)
			return;
		}

		if (cardComplete) {
			setProcessing(true);
		}


		const payload = await stripe.createPaymentMethod({
			type: 'card',
			// @ts-ignore
			card: elements.getElement(CardElement),
			billing_details: billingDetails
		});

		setProcessing(false);

		if (payload.error) {

			alert("errror : " + JSON.stringify(payload.error))
			// @ts-ignore
			setError(payload.error);
		} else {
			props.updateCC(payload)
			// @ts-ignore
			setPaymentMethod(payload.paymentMethod);
		}
	};

	const reset = () => {
		// @ts-ignore
		setError(null);
		setProcessing(false);
		setPaymentMethod(null);
		setBillingDetails({
			email: '',
			phone: '',
			name: '',
		});
	};

	return paymentMethod ? (
		<div className="Result">
			<div className="ResultTitle" role="alert">
				Payment successful
			</div>
			<div className="ResultMessage">
				Thanks for trying Stripe Elements. No money was charged, but we
				generated a PaymentMethod:
				{
					// @ts-ignore
					paymentMethod.id
				}
			</div>
			<ResetButton onClick={reset}/>
		</div>
	) : (
		<form className="Form" onSubmit={handleSubmit}>
			<fieldset className="FormGroup">
				<Field
					label="Name"
					id="name"
					type="text"
					placeholder="Jane Doe"
					required
					autoComplete="name"
					value={billingDetails.name}
					onChange={(e: any) => {
						setBillingDetails({...billingDetails, name: e.target.value});
					}}
				/>
				<Field
					label="Email"
					id="email"
					type="email"
					placeholder="janedoe@gmail.com"
					required
					autoComplete="email"
					value={billingDetails.email}
					onChange={(e: any) => {
						setBillingDetails({...billingDetails, email: e.target.value});
					}}
				/>
				<Field
					label="Phone"
					id="phone"
					type="tel"
					placeholder="(941) 555-0123"
					required
					autoComplete="tel"
					value={billingDetails.phone}
					onChange={(e: any) => {
						setBillingDetails({...billingDetails, phone: e.target.value});
					}}
				/>
			</fieldset>
			<fieldset className="FormGroup">

				<div className="FormRow">
					<CardElement options={CARD_OPTIONS} onChange={(e: any) => {
						setError(e.error);
						setCardComplete(e.complete);
					}}/>
				</div>

				{/*<CardField*/}
				{/*	onChange={(e: any) => {*/}
				{/*		setError(e.error);*/}
				{/*		setCardComplete(e.complete);*/}
				{/*	}}*/}
				{/*/>*/}
			</fieldset>

			{error && <ErrorMessage>{
				// @ts-ignore
				error.message
			}</ErrorMessage>}

			<button
				className={`SubmitButton ${error ? 'SubmitButton--error' : ''}`}
				type="submit"
				disabled={processing || !stripe}
			>
				{processing ? <span>'Processing...'</span> : <span>Pay {props.amount} € </span>}
			</button>
		</form>
	);
};


const CARD_OPTIONS = {};


const Field = ({label, id, type, placeholder, required, autoComplete, value, onChange}: any) => (
	<div className="FormRow">
		<label htmlFor={id} className="FormRowLabel">
			{label}
		</label>
		<input
			className="FormRowInput"
			id={id}
			type={type}
			placeholder={placeholder}
			required={required}
			autoComplete={autoComplete}
			value={value}
			onChange={onChange}
		/>
	</div>
);


const ErrorMessage = ({children}: any) => (
	<div className="ErrorMessage" role="alert">
		<svg width="16" height="16" viewBox="0 0 17 17">
			<path
				fill="#FFF"
				d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
			/>
			<path
				fill="#6772e5"
				d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
			/>
		</svg>
		{children}
	</div>
);

const ResetButton = ({onClick}: any) => (
	<button type="button" className="ResetButton" onClick={onClick}>
		<svg width="32px" height="32px" viewBox="0 0 32 32">
			<path
				fill="#FFF"
				d="M15,7.05492878 C10.5000495,7.55237307 7,11.3674463 7,16 C7,20.9705627 11.0294373,25 16,25 C20.9705627,25 25,20.9705627 25,16 C25,15.3627484 24.4834055,14.8461538 23.8461538,14.8461538 C23.2089022,14.8461538 22.6923077,15.3627484 22.6923077,16 C22.6923077,19.6960595 19.6960595,22.6923077 16,22.6923077 C12.3039405,22.6923077 9.30769231,19.6960595 9.30769231,16 C9.30769231,12.3039405 12.3039405,9.30769231 16,9.30769231 L16,12.0841673 C16,12.1800431 16.0275652,12.2738974 16.0794108,12.354546 C16.2287368,12.5868311 16.5380938,12.6540826 16.7703788,12.5047565 L22.3457501,8.92058924 L22.3457501,8.92058924 C22.4060014,8.88185624 22.4572275,8.83063012 22.4959605,8.7703788 C22.6452866,8.53809377 22.5780351,8.22873685 22.3457501,8.07941076 L22.3457501,8.07941076 L16.7703788,4.49524351 C16.6897301,4.44339794 16.5958758,4.41583275 16.5,4.41583275 C16.2238576,4.41583275 16,4.63969037 16,4.91583275 L16,7 L15,7 L15,7.05492878 Z M16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 Z"
			/>
		</svg>
	</button>
);


const ELEMENTS_OPTIONS = {
	fonts: [
		{
			cssSrc: 'https://fonts.googleapis.com/css?family=Roboto',
		},
	],
};


